import { render, staticRenderFns } from "./weight.vue?vue&type=template&id=6e773f98&scoped=true&"
import script from "./weight.vue?vue&type=script&lang=js&"
export * from "./weight.vue?vue&type=script&lang=js&"
import style0 from "./weight.vue?vue&type=style&index=0&id=6e773f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e773f98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e773f98')) {
      api.createRecord('6e773f98', component.options)
    } else {
      api.reload('6e773f98', component.options)
    }
    module.hot.accept("./weight.vue?vue&type=template&id=6e773f98&scoped=true&", function () {
      api.rerender('6e773f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/weight.vue"
export default component.exports